import { render, staticRenderFns } from "./BaseTeacherList.vue?vue&type=template&id=77322fa5"
import script from "./BaseTeacherList.vue?vue&type=script&lang=js"
export * from "./BaseTeacherList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports